window.addEventListener("load", function () {
    if ( document.querySelectorAll('.relatedProducts').length ) {

        const relatedProducts = document.querySelectorAll('.relatedProducts');

        relatedProducts.forEach(function(element) {
            mySwiper = new Swiper(element.querySelector(".swiper"), {
                slidesPerView: 1,
                spaceBetween: 20,
                watchOverflow: true,
                preloadImages: false,
                checkInView: true,
                loadPrevNext: true,
                lazy: true,
                breakpoints: {
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 25,
                    },
                    900: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 30,
                    },
                    1400: {
                        slidesPerView: 4,
                        spaceBetween: 35,
                    },
                    1800: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                    },
                    2200: {
                        slidesPerView: 4,
                        spaceBetween: 55,
                    },
                    2400: {
                        slidesPerView: 4,
                        spaceBetween: 75
                    }
                },
                navigation: {
                    nextEl: element.querySelector(".swiper-button-next"),
                    prevEl: element.querySelector(".swiper-button-prev"),
                },
            });
        });
    }
});
